import { apiGet } from './index'
// 获取科室总览-科室发展进度
const getGrowthOverview = (params) => apiGet('/api/johnson/senior-director', params)
// 获取科室总览-成长概览
const getDepDevelop = (params) => apiGet(`/api/johnson/senior-director-info/${params.multiCode}`, params)
export {
  getGrowthOverview,
  getDepDevelop
}



// WEBPACK FOOTER //
// ./src/api/departmentOverview.js